import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.representative.regions');
import { EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { Service } from "src/libs/portal/season/service";
import { RegionSelectionService } from 'src/app/region-selection.service';

interface RegionUiPosition {
    region_id: string;
    region_name: string;
    map_x_percent: number;
    map_y_percent: number;
    label_anchor: 'LEFT' | 'RIGHT' | 'TOP' | 'BOTTOM';
    label_offset_x: number;
    label_offset_y: number;
    z_index: number;
    mobile_display_order: number;
}

@Component({
    selector: 'wiz-component-representative-regions',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.representative.regions/view.scss */
@charset "UTF-8";
:host {
  display: block;
  width: 100%;
}

button,
select {
  font: inherit;
}

button:focus-visible,
select:focus-visible,
summary:focus-visible {
  outline: 3px solid rgba(43, 93, 135, 0.35);
  outline-offset: 2px;
}

table {
  border-collapse: separate;
  border-spacing: 0;
}

.filter-field {
  color: #334155;
  font-size: 11px;
  font-weight: 800;
}

.filter-field span {
  display: block;
}

.filter-field select {
  width: 100%;
  margin-top: 6px;
  border: 1px solid #cbd5e1;
  border-radius: 7px;
  background: #fff;
  padding: 10px 12px;
  color: #0f172a;
  font-size: 12px;
  font-weight: 700;
}

.map-filter-panel {
  grid-area: filters;
  min-width: 0;
  border: 1px solid #e2e8f0;
  border-radius: 7px;
  background: #fff;
  padding: 18px;
}

.map-filter-panel__head {
  border-bottom: 1px solid #e2e8f0;
  padding-bottom: 14px;
}

.map-filter-panel__head p {
  color: #285b8c;
  font-size: 10px;
  font-weight: 900;
  letter-spacing: 0.06em;
}

.map-filter-panel__head h2 {
  margin-top: 4px;
  color: #0f172a;
  font-size: 15px;
  font-weight: 850;
}

.map-filter-panel__head span,
.map-filter-panel__note {
  display: block;
  margin-top: 5px;
  color: #64748b;
  font-size: 10px;
  line-height: 1.55;
}

.map-filter-panel__fields {
  display: grid;
  gap: 13px;
  margin-top: 16px;
}

.map-filter-summary {
  display: grid;
  gap: 0;
  margin-top: 18px;
  border-top: 1px solid #e2e8f0;
}

.map-filter-summary div {
  display: grid;
  grid-template-columns: 68px minmax(0, 1fr);
  gap: 8px;
  border-bottom: 1px solid #f1f5f9;
  padding: 10px 0;
  font-size: 10px;
  line-height: 1.45;
}

.map-filter-summary dt {
  color: #64748b;
  font-weight: 750;
}

.map-filter-summary dd {
  color: #172231;
  font-weight: 800;
  text-align: right;
}

.map-filter-panel__note {
  margin-top: 13px;
}

.national-distribution-layout {
  display: grid;
  grid-template-areas: "filters map detail";
  grid-template-columns: minmax(210px, 240px) minmax(480px, 1fr) minmax(280px, 340px);
  gap: 20px;
  align-items: start;
}

.national-map-panel,
.national-detail-panel,
.ranking-panel {
  min-width: 0;
  border: 1px solid #e2e8f0;
  border-radius: 7px;
  background: #fff;
}

.national-map-panel,
.national-detail-panel {
  padding: 20px;
}

.national-map-panel {
  grid-area: map;
}

.national-detail-panel {
  grid-area: detail;
}

.national-map-title-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-top: 4px;
}

.map-boundary-badge {
  display: inline-flex;
  align-items: center;
  min-height: 24px;
  border: 1px solid #cbd5e1;
  border-radius: 999px;
  background: #f8fafc;
  padding: 3px 7px;
  color: #475569;
  font-size: 9px;
  font-weight: 800;
  cursor: help;
}

.map-boundary-badge:focus-visible {
  outline: 3px solid rgba(43, 93, 135, 0.35);
  outline-offset: 2px;
}

.national-map-shell {
  position: relative;
  margin-top: 16px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
}

.national-map-canvas {
  position: relative;
  width: min(100%, 680px);
  aspect-ratio: 1/1;
  margin: 0 auto;
}

.national-map-image {
  position: absolute;
  inset: 0;
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  pointer-events: none;
  user-select: none;
}

.national-map-fallback,
.national-map-loading {
  position: absolute;
  z-index: 30;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.92);
  color: #475569;
  font-size: 11px;
  font-weight: 700;
  text-align: center;
}

.national-map-fallback {
  inset: 45% 12% auto;
  padding: 12px;
}

.national-map-loading {
  inset: auto 16px 16px;
  padding: 9px 12px;
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.12);
}

.national-map-marker {
  --marker-color: #64748b;
  --marker-surface: #f1f5f9;
  position: absolute;
  z-index: var(--marker-z-index, 2);
  width: 44px;
  min-width: 44px;
  height: 44px;
  min-height: 44px;
  transform: translate(-50%, -50%);
  border: 0;
  border-radius: 999px;
  background: transparent;
  color: #0f172a;
  cursor: pointer;
  user-select: none;
}

.national-map-marker:hover {
  z-index: 40;
}

.national-map-marker:focus-visible {
  z-index: 41;
  outline: 3px solid #2563eb;
  outline-offset: 2px;
}

.national-map-marker__pin {
  position: absolute;
  inset: 4px;
  display: grid;
  place-items: center;
  border: 2px solid #fff;
  border-radius: 999px 999px 999px 5px;
  background: var(--marker-color);
  color: #fff;
  box-shadow: 0 3px 10px rgba(15, 23, 42, 0.28);
  transform: rotate(-45deg);
  transition: transform 160ms ease, box-shadow 160ms ease;
}

.national-map-marker__value {
  display: block;
  max-width: 30px;
  overflow: hidden;
  transform: rotate(45deg);
  font-size: 8px;
  font-weight: 900;
  line-height: 1.05;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.national-map-marker__label {
  position: absolute;
  z-index: 2;
  min-height: 28px;
  padding: 5px 7px;
  border: 1px solid color-mix(in srgb, var(--marker-color) 55%, white);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.12);
  color: #0f172a;
  font-size: 10px;
  font-weight: 900;
  line-height: 16px;
  white-space: nowrap;
  transform: translate(var(--label-offset-x, 0), var(--label-offset-y, 0));
}

.national-map-marker__label::before {
  position: absolute;
  border-color: color-mix(in srgb, var(--marker-color) 72%, #475569);
  content: "";
  pointer-events: none;
}

.national-map-marker--right .national-map-marker__label {
  left: calc(100% + 2px);
  top: 50%;
  margin-top: -14px;
}

.national-map-marker--right .national-map-marker__label::before {
  left: -9px;
  top: calc(50% - var(--label-offset-y, 0px));
  width: 8px;
  border-top-style: solid;
  border-top-width: 1px;
}

.national-map-marker--left .national-map-marker__label {
  right: calc(100% + 2px);
  top: 50%;
  margin-top: -14px;
}

.national-map-marker--left .national-map-marker__label::before {
  right: -9px;
  top: calc(50% - var(--label-offset-y, 0px));
  width: 8px;
  border-top-style: solid;
  border-top-width: 1px;
}

.national-map-marker--top .national-map-marker__label {
  left: 50%;
  bottom: calc(100% + 2px);
  margin-left: -24px;
}

.national-map-marker--top .national-map-marker__label::before {
  bottom: -9px;
  left: calc(24px - var(--label-offset-x, 0px));
  height: 8px;
  border-left-style: solid;
  border-left-width: 1px;
}

.national-map-marker--bottom .national-map-marker__label {
  left: 50%;
  top: calc(100% + 2px);
  margin-left: -24px;
}

.national-map-marker--bottom .national-map-marker__label::before {
  left: calc(24px - var(--label-offset-x, 0px));
  top: -9px;
  height: 8px;
  border-left-style: solid;
  border-left-width: 1px;
}

.national-map-marker:hover .national-map-marker__pin,
.national-map-marker:focus-visible .national-map-marker__pin {
  transform: rotate(-45deg) scale(1.1);
  box-shadow: 0 5px 16px rgba(15, 23, 42, 0.35);
}

.national-map-marker.is-selected {
  z-index: 45;
}

.national-map-marker.is-selected .national-map-marker__pin {
  box-shadow: 0 0 0 4px #fff, 0 0 0 7px #0f172a, 0 7px 18px rgba(15, 23, 42, 0.35);
}

.national-map-marker.is-selected .national-map-marker__label::after {
  content: "선택";
  margin-left: 5px;
  color: #2b5d87;
  font-size: 8px;
}

.national-map-marker--candidate {
  --marker-color: #047857;
}

.national-map-marker--single {
  --marker-color: #2b5d87;
}

.national-map-marker--low {
  --marker-color: #94a3b8;
}

.national-map-marker--unavailable {
  --marker-color: #64748b;
}

.national-map-marker--unavailable .national-map-marker__pin,
.legend-swatch--unavailable {
  background-color: #94a3b8;
  background-image: repeating-linear-gradient(135deg, rgba(255, 255, 255, 0.35) 0 3px, transparent 3px 7px);
}

.national-map-marker--status-unverified .national-map-marker__pin,
.national-map-marker--status-checking .national-map-marker__pin {
  border: 2px dashed #475569;
}

.national-map-marker--status-lq_only .national-map-marker__pin {
  border-color: #fff7ed;
  box-shadow: 0 0 0 3px #f59e0b, 0 3px 10px rgba(15, 23, 42, 0.28);
}

.national-map-marker__warning {
  position: absolute;
  right: -3px;
  top: -4px;
  z-index: 3;
  display: grid;
  width: 18px;
  height: 18px;
  place-items: center;
  border: 2px solid #fff;
  border-radius: 999px;
  background: #f59e0b;
  color: #451a03;
  font-size: 10px;
  font-weight: 950;
}

.map-legend {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  margin-top: 16px;
  font-size: 11px;
}

.legend-item {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #64748b;
}

.legend-swatch,
.legend-warning {
  display: inline-grid;
  flex: 0 0 auto;
  width: 16px;
  height: 16px;
  place-items: center;
  border-radius: 5px;
}

.legend-swatch--candidate {
  background: #047857;
}

.legend-swatch--single {
  background: #2b5d87;
}

.legend-swatch--low {
  background: #cbd5e1;
}

.legend-swatch--pending {
  border: 2px dashed #64748b;
  background: repeating-linear-gradient(135deg, #e2e8f0 0 3px, #f8fafc 3px 7px);
}

.legend-swatch--hold {
  border: 3px solid #f59e0b;
  background: #94a3b8;
}

.legend-swatch--selected {
  border: 3px solid #0f172a;
  background: #fff;
  box-shadow: 0 0 0 2px #c7d2fe;
}

.legend-warning {
  border-radius: 999px;
  background: #f59e0b;
  color: #451a03;
  font-size: 10px;
  font-weight: 900;
}

.province-mobile-list {
  display: none;
}

.map-disclaimer {
  margin-top: 15px;
  border-top: 1px solid #e2e8f0;
  padding-top: 13px;
  color: #64748b;
  font-size: 10px;
  line-height: 1.7;
}

.national-detail-panel {
  align-self: stretch;
}

.national-detail-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.data-status {
  display: inline-flex;
  flex: 0 0 auto;
  max-width: 180px;
  border: 1px solid transparent;
  border-radius: 999px;
  padding: 5px 8px;
  font-size: 9px;
  font-weight: 900;
  line-height: 1.35;
  text-align: center;
}

.data-status--policy_ready {
  border-color: #a7f3d0;
  background: #ecfdf5;
  color: #047857;
}

.data-status--lq_only {
  border-color: #fde68a;
  background: #fffbeb;
  color: #92400e;
}

.data-status--unverified,
.data-status--checking {
  border-color: #cbd5e1;
  background: #f1f5f9;
  color: #475569;
}

.detail-section {
  margin-top: 18px;
  border-top: 1px solid #e2e8f0;
  padding-top: 16px;
}

.detail-section h4 {
  color: #334155;
  font-size: 11px;
  font-weight: 900;
  letter-spacing: 0.02em;
}

.detail-industry {
  margin-top: 7px;
  color: #0f172a;
  font-size: 13px;
  font-weight: 850;
  line-height: 1.5;
}

.detail-metric-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  margin-top: 12px;
}

.metric-card {
  min-height: 67px;
  border-radius: 11px;
  background: #f8fafc;
  padding: 10px;
}

.metric-card p {
  color: #64748b;
  font-size: 11px;
  font-weight: 700;
}

.metric-card strong {
  display: block;
  margin-top: 5px;
  color: #0f172a;
  font-size: 13px;
  line-height: 1.35;
}

.small-base-warning,
.policy-hold {
  margin-top: 10px;
  border-radius: 10px;
  padding: 10px 11px;
  font-size: 10px;
  line-height: 1.6;
}

.small-base-warning {
  background: #fff7ed;
  color: #9a3412;
  font-weight: 750;
}

.policy-hold {
  border: 1px solid #fde68a;
  background: #fffbeb;
  color: #78350f;
}

.policy-hold strong {
  display: block;
  margin-bottom: 4px;
}

.detail-policy-list {
  display: grid;
  gap: 8px;
  margin-top: 10px;
}

.detail-policy-list div {
  display: grid;
  grid-template-columns: 90px minmax(0, 1fr);
  gap: 8px;
  font-size: 10px;
  line-height: 1.55;
}

.detail-policy-list dt {
  color: #64748b;
  font-weight: 800;
}

.detail-policy-list dd {
  color: #0f172a;
  font-weight: 750;
}

.detail-section--muted {
  color: #64748b;
  font-size: 10px;
  line-height: 1.7;
}

.detail-actions {
  display: grid;
  gap: 8px;
  margin-top: 18px;
}

.detail-actions button {
  min-height: 44px;
  border: 1px solid #c7d2fe;
  border-radius: 10px;
  background: #fff;
  padding: 9px 12px;
  color: #4338ca;
  font-size: 11px;
  font-weight: 850;
}

.detail-actions button:first-child {
  border-color: #0f172a;
  background: #0f172a;
  color: #fff;
}

.layer-card {
  min-height: 130px;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  background: #f8fafc;
  padding: 16px;
  color: #475569;
  font-size: 12px;
  line-height: 1.8;
}

.layer-card h4 {
  margin: 4px 0 10px;
  color: #0f172a;
  font-size: 14px;
  font-weight: 800;
}

.layer-card__eyebrow {
  color: #4f46e5;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.06em;
}

.ranking-panel {
  scroll-margin-top: 20px;
  overflow: hidden;
}

.ranking-head {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: 12px;
  border-bottom: 1px solid #e2e8f0;
  padding: 20px 24px;
}

.ranking-panel th,
.ranking-panel td {
  padding: 12px;
  color: #475569;
  font-size: 11px;
  vertical-align: top;
}

.ranking-panel th {
  color: #475569;
  font-weight: 800;
  white-space: nowrap;
}

.ranking-panel td strong,
.ranking-panel td small {
  display: block;
}

.ranking-panel td small {
  margin-top: 3px;
  color: #94a3b8;
  font-size: 9px;
}

.table-region-button {
  min-height: 44px;
  border: 0;
  background: transparent;
  color: #0f172a;
  font-size: 11px;
  font-weight: 900;
  text-decoration: underline;
  text-decoration-color: #c7d2fe;
  text-underline-offset: 3px;
  cursor: pointer;
}

.explain-box {
  border: 1px solid #c7d2fe;
  border-radius: 14px;
  background: #eef2ff;
  padding: 16px;
}

.explain-box summary {
  cursor: pointer;
  color: #3730a3;
  font-size: 12px;
  font-weight: 800;
}

@media (max-width: 1180px) {
  .national-distribution-layout {
    grid-template-areas: "filters filters" "map detail";
    grid-template-columns: minmax(0, 3fr) minmax(300px, 2fr);
  }
  .map-filter-panel__fields {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  .map-filter-summary {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  .map-filter-summary div {
    display: block;
    border-right: 1px solid #f1f5f9;
    padding: 10px;
  }
  .map-filter-summary dd {
    margin-top: 4px;
    text-align: left;
  }
}
@media (max-width: 840px) {
  .national-distribution-layout {
    grid-template-areas: "filters" "map" "detail";
    grid-template-columns: 1fr;
  }
  .map-filter-panel__fields {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .map-filter-summary {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .national-detail-panel {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0 18px;
  }
  .national-detail-head,
  .detail-actions {
    grid-column: 1/-1;
  }
}
@media (max-width: 760px) {
  .map-filter-panel,
  .national-map-panel,
  .national-detail-panel {
    padding: 14px;
  }
  .map-filter-panel__fields,
  .map-filter-summary {
    grid-template-columns: 1fr;
  }
  .map-filter-summary div {
    display: grid;
    border-right: 0;
    padding: 10px 0;
  }
  .map-filter-summary dd {
    margin-top: 0;
    text-align: right;
  }
  .national-map-marker__label,
  .national-map-marker__value {
    display: none;
  }
  .national-map-marker__pin {
    inset: 8px;
  }
  .province-mobile-list {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
    margin-top: 14px;
  }
  .province-mobile-list button {
    min-height: 46px;
    border: 1px solid #cbd5e1;
    border-radius: 10px;
    background: #fff;
    padding: 8px 10px;
    color: #334155;
    text-align: left;
  }
  .province-mobile-list button.is-selected {
    border-color: #0f172a;
    box-shadow: inset 0 0 0 2px #0f172a;
  }
  .province-mobile-list span,
  .province-mobile-list small {
    display: block;
  }
  .province-mobile-list span {
    font-size: 11px;
    font-weight: 850;
  }
  .province-mobile-list small {
    margin-top: 2px;
    color: #64748b;
    font-size: 9px;
  }
  .national-detail-panel {
    display: block;
  }
  .map-legend,
  .detail-metric-grid {
    grid-template-columns: 1fr;
  }
  .ranking-head {
    padding: 16px;
  }
}`],
})
export class ComponentRepresentativeRegionsComponent implements OnInit, OnChanges {
    @Input() public selectedDetailRegionKey: string = 'daejeon';
    @Output() public detailRegionRequested = new EventEmitter<string>();

    public readonly mapImagePath = '/assets/brand/3d-map-with-borders-regions_97886-11245.jpg';
    public dataset: any = null;
    public policyDistribution: any = null;
    public positions: RegionUiPosition[] = [];
    public loading: boolean = true;
    public distributionLoading: boolean = false;
    public mapImageAvailable: boolean | null = null;
    public errorMessage: string = '';
    public distributionError: string = '';
    public selectedIndustry: string = '30';
    public selectedPolicyGoal: string = 'GROWTH_PROMOTION';
    public selectedMetric: string = 'representative_type';
    public selectedDataStatus: string = 'ALL';
    public selectedSort: string = 'representative_score';
    public selectedProvinceKey: string = 'daejeon';
    public mapMetricOptions: any[] = [
        { key: 'representative_type', label: '대표 산업 지역 유형' },
        { key: 'representative_score', label: '대표성 점수' },
        { key: 'business_lq', label: '사업체 LQ' },
        { key: 'employment_lq', label: '종사자 LQ' },
        { key: 'policy_score', label: '정책 우선순위 점수' },
        { key: 'dual_specialization', label: '이중 특화 여부' },
        { key: 'business_cagr', label: '사업체 CAGR' },
        { key: 'employment_cagr', label: '종사자 CAGR' },
        { key: 'lq_trend', label: 'LQ 추세' },
    ];
    constructor(@Inject( Service)         public service: Service,@Inject( RegionSelectionService)         public regionSelection: RegionSelectionService,@Inject( HttpClient)         private http: HttpClient,    ) { }

    public async ngOnInit() {
        await this.service.init();
        await this.regionSelection.loadTree();
        await Promise.all([this.loadPositions(), this.loadAnalysis()]);
    }

    public async ngOnChanges(changes: SimpleChanges) {
        if (changes.selectedDetailRegionKey && this.dataset) {
            this.syncProvinceToDetail();
            await this.service.render();
        }
    }

    public async loadAnalysis() {
        this.loading = true;
        this.errorMessage = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('analysis', {
                reference_year: this.regionSelection.referenceYear,
            });
            if (code !== 200 || !data) throw new Error(data?.message || '전국 산업 특화 데이터를 불러오지 못했습니다.');
            this.dataset = data;
            this.selectedPolicyGoal = data.meta?.default_policy_goal_key || 'GROWTH_PROMOTION';
            this.syncProvinceToDetail();
            await this.loadPolicyDistribution();
        } catch (error) {
            this.errorMessage = error?.message || '전국 산업 특화 데이터 요청 중 오류가 발생했습니다.';
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public async loadPolicyDistribution() {
        if (!this.dataset) return;
        this.distributionLoading = true;
        this.distributionError = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('policy_distribution', {
                reference_year: this.regionSelection.referenceYear,
                industry_code: this.selectedIndustry,
                goal_key: this.selectedPolicyGoal,
            });
            if (code !== 200 || !data?.rows) throw new Error(data?.message || '정책 연계 분포를 불러오지 못했습니다.');
            this.policyDistribution = data;
            if (!this.provinceRows.some((row: any) => row.region_key === this.selectedProvinceKey)) {
                this.selectedProvinceKey = this.provinceRows[0]?.region_key || '';
            }
        } catch (error) {
            this.policyDistribution = null;
            this.distributionError = error?.message || '정책 상태는 확인하지 못했으며 LQ 데이터만 표시합니다.';
        } finally {
            this.distributionLoading = false;
            await this.service.render();
        }
    }

    private async loadPositions() {
        const payload: any = await firstValueFrom(this.http.get('/assets/data/region-ui-position.json'));
        this.positions = Array.isArray(payload?.positions) ? payload.positions : [];
        await this.service.render();
    }

    private syncProvinceToDetail() {
        const selectedNode = this.regionSelection.resolve(this.selectedDetailRegionKey);
        const provinceNode = selectedNode?.region_type === 'METROPOLITAN'
            ? selectedNode
            : this.regionSelection.resolve(selectedNode?.parent_region_id || '');
        this.selectedProvinceKey = provinceNode?.analysis_key || this.selectedProvinceKey || 'daejeon';
    }

    public get activeIndustry() {
        if (!this.selectedIndustry) return null;
        return this.dataset?.industries?.find((item: any) => item.code === this.selectedIndustry) || null;
    }

    public get activeGoal() {
        return this.dataset?.policy_goals?.find((item: any) => item.key === this.selectedPolicyGoal)
            || this.policyDistribution?.policy_goal
            || null;
    }

    public get activeSummary() {
        return this.dataset?.summaries?.find((item: any) => item.industry_code === this.selectedIndustry) || null;
    }

    private get allProvinceRows() {
        if (this.policyDistribution?.rows?.length) return this.policyDistribution.rows;
        return this.selectedIndustry ? (this.dataset?.by_industry?.[this.selectedIndustry] || []) : [];
    }

    public get provinceRows() {
        return this.allProvinceRows.filter((row: any) => this.isPublicPolicyRow(row));
    }

    public isPublicPolicyRow(row: any): boolean {
        if (!row || row.policy_ready !== true) return false;
        const statusCode = row.policy_status_code || row.status_code || row.primary_status || row.hold_reason_code;
        if (statusCode && !['RECOMMENDATION_AVAILABLE', 'POLICY_READY'].includes(statusCode)) return false;
        if (row.source_status && row.source_status !== 'APPROVED_SOURCE_FOUND') return false;
        if (row.recalculation_status && row.recalculation_status !== 'POLICY_READY') return false;
        if (Array.isArray(row.blocking_reasons) && row.blocking_reasons.length) return false;
        if (['JOIN_KEY_MISSING', 'BRIDGE_MISSING'].includes(row.join_status)) return false;
        if (row.qa_scope_status && row.qa_scope_status !== 'VERIFIED') return false;
        return ['검증 완료', '통과', '확인'].includes(row.validation_status);
    }

    public get displayRows() {
        const rows = this.provinceRows;
        const fields: any = {
            representative_score: 'representative_score',
            business_lq: 'business_lq',
            employment_lq: 'employment_lq',
            policy_score: 'policy_score',
        };
        const field = fields[this.selectedSort] || 'representative_score';
        return [...rows].sort((left: any, right: any) => {
            const leftValue = left[field];
            const rightValue = right[field];
            if (leftValue === null || leftValue === undefined) return 1;
            if (rightValue === null || rightValue === undefined) return -1;
            return rightValue - leftValue || left.region_name.localeCompare(right.region_name, 'ko');
        });
    }

    public get mobileProvinceRows() {
        const order = new Map(this.positions.map(item => [item.region_id, item.mobile_display_order]));
        return [...this.provinceRows].sort((left: any, right: any) =>
            (order.get(left.region_id) || 999) - (order.get(right.region_id) || 999)
        );
    }

    public get selectedProvinceRow() {
        return this.provinceRows.find((row: any) => row.region_key === this.selectedProvinceKey) || this.provinceRows[0] || null;
    }

    private get detailIndustryCode() {
        return this.selectedIndustry || this.selectedProvinceRow?.industry_code || '';
    }

    public get selectedDetailRow() {
        const rows = this.dataset?.detail_by_industry?.[this.detailIndustryCode] || [];
        return rows.find((row: any) => row.region_key === this.selectedDetailRegionKey) || null;
    }

    public get topCandidates() {
        return this.provinceRows.filter((row: any) => row.representative_candidate).slice(0, 3);
    }

    public get relatedDetailRows() {
        const rows = this.dataset?.detail_by_industry?.[this.detailIndustryCode] || [];
        const provinceId = this.selectedProvinceRow?.region_id;
        return rows.filter((row: any) => row.region_id === provinceId || row.parent_region_id === provinceId);
    }

    public get policyReadyCount() {
        return this.provinceRows.filter((row: any) => row.policy_ready).length;
    }

    public async changeIndustry(event: any) {
        this.selectedIndustry = event?.target?.value ?? '30';
        this.policyDistribution = null;
        await this.loadPolicyDistribution();
    }

    public async changeProvince(event: any) {
        const regionKey = event?.target?.value || '';
        const row = this.provinceRows.find((item: any) => item.region_key === regionKey);
        if (!row) return;
        await this.selectProvince(row);
    }

    public async changePolicyGoal(event: any) {
        this.selectedPolicyGoal = event?.target?.value || 'GROWTH_PROMOTION';
        this.policyDistribution = null;
        await this.loadPolicyDistribution();
    }

    public async changeMetric(event: any) {
        this.selectedMetric = event?.target?.value || 'representative_type';
        await this.service.render();
    }

    public async changeDataStatus(event: any) {
        this.selectedDataStatus = event?.target?.value || 'ALL';
        await this.service.render();
    }

    public async changeSort(event: any) {
        this.selectedSort = event?.target?.value || 'representative_score';
        await this.service.render();
    }

    public async selectProvince(row: any) {
        this.selectedProvinceKey = row.region_key;
        this.detailRegionRequested.emit(row.region_id || row.region_key);
        await this.service.render();
    }

    public async selectDetailRegion(regionKey: string) {
        this.detailRegionRequested.emit(regionKey);
        this.selectedDetailRegionKey = regionKey;
        this.syncProvinceToDetail();
        await this.service.render();
    }

    public positionStyle(row: any): Record<string, string> {
        const position = this.positions.find(item => item.region_id === row?.region_id);
        return position ? {
            left: `${position.map_x_percent}%`,
            top: `${position.map_y_percent}%`,
            '--marker-z-index': `${position.z_index || 2}`,
            '--label-offset-x': `${position.label_offset_x}px`,
            '--label-offset-y': `${position.label_offset_y}px`,
        } : { display: 'none' };
    }

    public positionAnchorClass(row: any) {
        const position = this.positions.find(item => item.region_id === row?.region_id);
        return `national-map-marker--${(position?.label_anchor || 'RIGHT').toLowerCase()}`;
    }

    public mapMarkerClass(row: any) {
        const selected = row.region_key === this.selectedProvinceKey ? ' is-selected' : '';
        const dataStatus = this.dataStatusKey(row).toLowerCase();
        return `national-map-marker national-map-marker--${this.mapCategory(row)} national-map-marker--status-${dataStatus} ${this.positionAnchorClass(row)}${selected}`;
    }

    public mapCategory(row: any) {
        if (!this.isPublicPolicyRow(row)) return 'unavailable';
        if (row.representative_candidate) return 'candidate';
        if (row.business_lq > 1 || row.employment_lq > 1) return 'single';
        return 'low';
    }

    public mapCategoryLabel(row: any) {
        const labels: any = {
            candidate: '이중 특화·대표 후보',
            single: '단일 특화 신호',
            low: '특화 신호 낮음',
            unavailable: '상세 결과 미제공',
        };
        return labels[this.mapCategory(row)];
    }

    public mapMetricValue(row: any) {
        if (!row) return '—';
        if (this.selectedMetric === 'business_lq') return this.formatLq(row.business_lq);
        if (this.selectedMetric === 'employment_lq') return this.formatLq(row.employment_lq);
        if (this.selectedMetric === 'representative_score') return this.formatScore(row.representative_score);
        if (this.selectedMetric === 'policy_score') return this.isPublicPolicyRow(row) ? this.formatScore(row.policy_score) : '—';
        if (this.selectedMetric === 'business_cagr') return this.formatPercent(row.business_cagr);
        if (this.selectedMetric === 'employment_cagr') return this.formatPercent(row.employment_cagr);
        if (this.selectedMetric === 'lq_trend') return row.lq_trend || '미확인';
        if (this.selectedMetric === 'dual_specialization') return row.dual_specialization ? '이중 특화' : '해당 없음';
        return row.representative_type || '추가 검토 필요';
    }

    public mapMetricShort(row: any) {
        if (this.selectedMetric === 'representative_type') return this.mapCategoryLabel(row);
        return this.mapMetricValue(row);
    }

    public mapTooltip(row: any) {
        return [
            `${row.region_name} / ${row.industry_name}`,
            `사업체 LQ ${this.formatLq(row.business_lq)} · 종사자 LQ ${this.formatLq(row.employment_lq)}`,
            `대표성 ${this.formatScore(row.representative_score)} · ${this.mapCategoryLabel(row)}`,
            `공개 상태 ${this.dataStatusLabel(row)}`,
            `정책점수 ${this.formatScore(row.policy_score)} · ${this.lowiLabel(row)}`,
        ].join('\n');
    }

    public shortRegionName(row: any) {
        return String(row?.region_name || '').replace(/특별자치도|특별자치시|광역시|특별시|도$/u, '');
    }

    public dataStatusKey(row: any) {
        return this.isPublicPolicyRow(row) ? 'POLICY_READY' : 'UNAVAILABLE';
    }

    public dataStatusLabel(row: any) {
        const labels: any = {
            POLICY_READY: '정책 결과 제공',
            UNAVAILABLE: '상세 결과 미제공',
        };
        return labels[this.dataStatusKey(row)];
    }

    public dataStatusClass(row: any) {
        return `data-status data-status--${this.dataStatusKey(row).toLowerCase()}`;
    }

    public hasSmallBaseWarning(row: any) {
        return Boolean(
            (row?.business_lq > 1 || row?.employment_lq > 1)
            && (row?.business_count_rank >= 15 || row?.employment_count_rank >= 15)
        );
    }

    public policyNeedLabel(row: any) {
        const need = row?.policy_need;
        if (Array.isArray(need)) return need.join(' · ') || '정책수요 확인 중';
        return need || '정책수요 확인 중';
    }

    public lowiLabel(row: any) {
        return row?.policy_type?.join(' · ') || '—';
    }

    public natoLabel(row: any) {
        return row?.nato_instruments?.join(' · ') || '—';
    }

    public packageLabel(row: any) {
        return row?.policy_package?.policy_package_name || row?.policy_package?.package_name || '—';
    }

    public focusIndustrySelector() {
        document.getElementById('public-map-industry')?.focus();
    }

    public detailSignal(row: any) {
        if (!row) return '추가 검토 필요';
        if (row.dual_specialization) return '시군구 이중 특화 사례';
        if (row.business_lq > 1 || row.employment_lq > 1) return '시군구 단일 특화 사례';
        if (row.growth_watch) return '시군구 성장관찰 사례';
        return '시군구 상대적 특화 신호 낮음';
    }

    public typeClass(type: string) {
        if (type?.includes('고용집중형')) return 'bg-emerald-100 text-emerald-700';
        if (type?.includes('산업생태계형')) return 'bg-indigo-100 text-indigo-700';
        if (type?.includes('성장관찰')) return 'bg-amber-100 text-amber-700';
        if (type?.includes('이중 특화')) return 'bg-sky-100 text-sky-700';
        if (type?.includes('단일')) return 'bg-violet-100 text-violet-700';
        return 'bg-slate-100 text-slate-600';
    }

    public formatLq(value: number) {
        if (value === null || value === undefined) return '—';
        return Number(value).toFixed(2);
    }

    public formatCount(value: number) {
        if (value === null || value === undefined) return '—';
        return Number(value).toLocaleString('ko-KR');
    }

    public formatScore(value: number) {
        if (value === null || value === undefined) return '비교 제외';
        return `${Number(value).toFixed(1)}점`;
    }

    public formatPercent(value: number) {
        if (value === null || value === undefined) return '성장성 미확인';
        return `${Number(value).toFixed(2)}%`;
    }

    public onMapImageLoad() {
        this.mapImageAvailable = true;
    }

    public onMapImageError() {
        this.mapImageAvailable = false;
    }

    public scrollToRanking(sort: string = this.selectedSort) {
        this.selectedSort = sort;
        void this.service.render();
        window.setTimeout(() => document.getElementById('province-ranking-table')?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 0);
    }

    public sendToSimulator(row: any) {
        if (!this.isPublicPolicyRow(row)) return;
        this.regionSelection.selectByRef(row.region_id || row.region_key);
        const handoff = {
            reference_year: row.data_year || this.dataset?.meta?.reference_year || this.dataset?.meta?.year,
            region_id: row.region_id || row.region_key,
            region_key: row.region_key,
            region_name: row.region_name,
            region_level: row.region_level,
            parent_region_id: row.parent_region_id,
            industry_code: row.industry_code,
            industry_name: row.industry_name,
            policy_goal_key: this.selectedPolicyGoal,
            policy_goal_name: this.activeGoal?.label,
            business_count: row.business_count,
            employment_count: row.employment_count,
            business_lq: row.business_lq,
            employment_lq: row.employment_lq,
            dual_specialization: row.dual_specialization,
            representative_type: row.representative_type,
            representative_score: row.representative_score,
            representative_candidate_rank: row.representative_candidate_rank,
            business_cagr: row.business_cagr,
            employment_cagr: row.employment_cagr,
            lq_trend: row.lq_trend,
            lq_ready: row.lq_ready,
            policy_ready: row.policy_ready,
            hold_reason: row.hold_reason,
            data_level: row.region_level,
            parent_province_reference: row.region_level === '시군구' ? this.selectedProvinceRow : null,
        };
        window.sessionStorage.setItem('reviewops-representative-handoff-v1', JSON.stringify(handoff));
        window.location.assign('/policy-simulator');
    }

    public sendToRegionalAnalysis(row: any) {
        if (!this.isPublicPolicyRow(row)) return;
        const regionId = row.region_id || row.region_key;
        this.regionSelection.selectByRef(regionId);
        const query = new URLSearchParams({
            region_id: regionId,
            region_type: row.region_type || '',
            parent_region_id: row.parent_region_id || '',
            region_name: row.region_name || '',
            industry_code: row.industry_code || '',
            industry_name: row.industry_name || '',
            policy_goal: this.selectedPolicyGoal,
            data_year: String(row.data_year || this.dataset?.meta?.reference_year || this.dataset?.meta?.year || ''),
        });
        window.location.assign(`/regional-analysis?${query.toString()}`);
    }
}

export default ComponentRepresentativeRegionsComponent;